import React, { useMemo } from 'react';

import { observer } from 'mobx-react';

import { LbPagination } from '@infoods/lifebase-ui';

import classes from './PreRegisteredTable.module.scss';
import { TitleRow } from './TitleRow/TitleRow';
import { PreRegisteredRow } from './PreRegisteredRow/PreRegisteredRow';
import { EmptyList } from '../../../../shared/components/ui-components';
import { preRegisteredStore } from '../../../stores/preRegisteredStore';
import {
  COLUMN_WIDTHS,
  PRE_REGISTERED_COLUMN,
  ShowColumnsConfig,
} from './PreRegisteredTable.settings';
import { getVisibleColumns } from '../../../../shared/components/table-components';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';

const PreRegisteredTable = observer(() => {
  const { isCoach } = loggedInUserDataStore;
  const { preRegisteredList, filterMethods } = preRegisteredStore;
  const { isShowPlaceholder, totalElements, elementsPerPage, getPaginationProps } =
    filterMethods;

  const showColumnsConfig = useMemo<ShowColumnsConfig>(
    () => ({
      [PRE_REGISTERED_COLUMN.NAME]: true,
      [PRE_REGISTERED_COLUMN.COACH]: !isCoach,
      [PRE_REGISTERED_COLUMN.DATE_OF_UPDATE]: true,
    }),
    [isCoach],
  );

  const { visibleColumns, gridTemplateColumns } = getVisibleColumns({
    columnEnum: PRE_REGISTERED_COLUMN,
    showColumnsConfig,
    columnWidths: COLUMN_WIDTHS,
  });

  return (
    <>
      <div className={classes.preRegisteredTable} style={{ gridTemplateColumns }}>
        <TitleRow visibleColumns={visibleColumns} />
        {preRegisteredList.map((customer) => (
          <PreRegisteredRow
            key={customer.id}
            customer={customer}
            visibleColumns={visibleColumns}
          />
        ))}
      </div>
      <EmptyList
        show={isShowPlaceholder}
        description="There are no pre-registered customers"
        size="small"
      />
      <LbPagination
        totalElements={totalElements}
        elementsPerPage={elementsPerPage}
        variant="inBox"
        {...getPaginationProps()}
      />
    </>
  );
});

export { PreRegisteredTable };
